<template>
  <div class="flex relative min-h-full flex-1 flex-col justify-center items-center px-6 py-12 lg:px-8">
    <div class="hidden sm:block absolute -z-10 inset-0 pointer-events-none aria-hidden opacity-30">
      <img src="/images/view-mock.jpg" alt="" class="w-full h-full object-cover">
    </div>

    <div class="bg-white rounded-xl sm:shadow sm:max-w-fit p-4 sm:p-20">
      <div class="sm:mx-auto sm:w-full sm:max-w-sm">
        <CompanyLogo class="mx-auto h-10 w-auto text-primary-700" />
        <h2 class="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
          Sign in to your account
        </h2>
      </div>

      <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form class="space-y-6" @submit.prevent="onSubmit">
          <div>
            <label for="email" class="block text-sm font-medium leading-6 text-gray-900">Email address</label>
            <div class="mt-2">
              <input
                id="email"
                v-model="email"
                name="email"
                type="email"
                autocomplete="email"
                required
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
              >
            </div>
          </div>

          <div>
            <div class="flex items-center justify-between">
              <label for="password" class="block text-sm font-medium leading-6 text-gray-900">Password</label>
              <div v-if="false" class="text-sm">
                <a href="#" class="font-semibold text-primary-600 hover:text-primary-500">Forgot password?</a>
              </div>
            </div>
            <div class="mt-2">
              <input
                id="password"
                v-model="password"
                name="password"
                type="password"
                autocomplete="current-password"
                required
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
              >
            </div>
          </div>

          <div>
            <button type="submit" class="flex w-full justify-center rounded-md bg-primary-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600">
              Sign in
            </button>
          </div>
        </form>

        <p v-if="false" class="mt-10 text-center text-sm text-gray-500">
          Not a member?
          {{ ' ' }}
          <a href="#" class="font-semibold leading-6 text-primary-600 hover:text-primary-500">Start a 14 day free trial</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import CompanyLogo from '../components/CompanyLogo.vue';
import { login, isLoggedInUser } from '../composables/useAuth';
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

const email = ref('');
const password = ref('');

watch(isLoggedInUser, value => {
  if (value) {
    router.push('/');
  }
});

function onSubmit() {
  login(email.value, password.value);
}
</script>
